function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#2d2d2d;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "bootstrap");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M75,80.93c0,10.81-10.12,10.56-11.19,10.56H43.14V70.66H63.77C74.62,70.66,75,78.8,75,80.93ZM62.18,62.28c.17,0,9.8.26,9.8-9.25,0-4-.9-9.15-9.8-9.15h-19v18.4ZM114.66,28.6v76.14a19.1,19.1,0,0,1-19,19H19.48a19.1,19.1,0,0,1-19-19V28.6a19.1,19.1,0,0,1,19-19H95.62A19.1,19.1,0,0,1,114.66,28.6Zm-28,53.84c0-5.5-1.7-14.86-12.51-17.17v-.19c5.84-2.49,9.52-7.2,9.52-14.18,0-1.79.51-16.52-19.78-16.52H31.48V101c32.69,0,35.66.43,41.71-1.46C76.81,98.43,86.63,95,86.63,82.44Z",
  transform: "translate(-0.44 -9.56)"
});

var SvgBootstrap = function SvgBootstrap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 114.22 114.22",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBootstrap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bootstrap.df01ebcf.svg";
export { ForwardRef as ReactComponent };